import { render } from "./TournamentOverview.vue?vue&type=template&id=41835809&scoped=true"
import script from "./TournamentOverview.vue?vue&type=script&lang=js"
export * from "./TournamentOverview.vue?vue&type=script&lang=js"

import "./TournamentOverview.vue?vue&type=style&index=0&id=41835809&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41835809"]])

export default __exports__